export const FIREBASE_API_KEY = "AIzaSyCEv03lKz6KWByq1qUFFiWvJVdtcW2WDpw";
export const FIREBASE_PROJECT_ID = "rbegc-223ce";
export const FIREBASE_AUTH_DOMAIN = `${FIREBASE_PROJECT_ID}.firebaseapp.com`;
export const FIREBASE_STORAGE_BUCKET = `gs://${FIREBASE_PROJECT_ID}.appspot.com`;
